import {
  EXERCISE_TYPE_TO_KEY,
  getTypesFiltersExercisesSelector
} from '@gymaholic/packages'

export default function handleTypesSyncReduxToUrlAction ({ searchParamsStr }) {
  return (dispatch, getState) => {
    const typesFilters = getTypesFiltersExercisesSelector(getState())

    if (!typesFilters.length) {
      return searchParamsStr
    }

    let typesQueryParam = ''
    typesFilters.map((typeId, index) => {
      const typeName = EXERCISE_TYPE_TO_KEY[typeId].toLowerCase().replace(/_/g, ' ')
      if (index === 0) {
        typesQueryParam = typesQueryParam + typeName
      } else {
        typesQueryParam = typesQueryParam + `,${typeName}`
      }
      return null
    })

    if (searchParamsStr.length > 0) {
      return searchParamsStr + `&types=${typesQueryParam}`
    }

    return searchParamsStr + `types=${typesQueryParam}`
  }
}
